<template>
  <div class="component-content">
    <div class="list-title">
      <div class="filter-item">
        <label>审批类型：</label>
        <el-select clearable v-model="form.approvalType" size="mini" placeholder="请选择">
          <el-option v-for="item,i in approvalTypeName" :key="item" :label="item" :value="i">
          </el-option>
        </el-select>
      </div>
      <div class="item-input" style="margin-top:5px;">
        <el-input v-model="form.searchName" size="mini" placeholder="你可以搜索审批主体/负责人"></el-input>
      </div>
    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="2">我提交的审批</el-radio-button>
        <el-radio-button label="0">待审批</el-radio-button>
        <el-radio-button label="1">您已审批</el-radio-button>
      </el-radio-group>
    </div>


    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <!-- <div class="no-list" v-else-if="paginationData.length<1">
      <p>暂无需要您审批的工程项目</p>
    </div> -->
    <!-- <div v-else style="overflow:hidden;"> -->
    <ul class="card-room" v-infinite-scroll="addCurrentPage" infinite-scroll-disabled="disabled"
      infinite-scroll-distance="50">
      <li class="card-item" v-for="item, i in paginationData">
        <div class="title">
          <div class="r"><span v-html="getApprovalTypeName(item)"></span></div>
          <h3 class="name">{{item.name}}</h3>
        </div>
        <div class="info">
          <p class="info-type" v-if="item.type==0||item.type==1">申请事由：{{ item.flow.remark?item.flow.remark:'无' }}</p>
          <!-- <p class="info-type">审批类型：{{approvalTitle["key_"+item.type]}}</p> -->
          <p>{{item.department}}</p>
          <p>当前审批状态：{{item.flow.status}}</p>
          <p>审批发起人：{{ item.creator.name+" - "+(item.creator.telephone?item.creator.telephone:item.creator.mobile) }}
          </p>
          <p>审批提交时间：<span v-html="getDateByTime(item.createTime)"></span></p>
          <div class="tool">
            <router-link :to="'/m/Approval/Info/'+item.id+'/'+item.type">
              <el-button plain size="small">详情</el-button>
            </router-link>
            <el-button v-if="item.flow.isCurUser && !item.flow.isCurUserArrpoval" size="mini" @click="arpproval(item)"
              type="primary">审批</el-button>
          </div>
        </div>
      </li>
    </ul>
    <!-- </div> -->
    <p style="text-align:center" v-if="loading">加载中...</p>
    <p style="text-align:center" v-if="noMore">没有更多了</p>

    <!-- <project-info></project-info> -->
  </div>
</template>

<script>
  import approvalList from '@/Mixins/approvalList'
  export default {
    mixins: [approvalList],
    computed: {
      noMore() {
        return this.paginationData.length >= this.pageTotal
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
    methods: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/m/approvallist.vue